import {ResearchLitElement, html, css} from '@core/research-lit-element';

import '@bog-design-system/bd-tabs';

export class ResearchTabSelector extends ResearchLitElement {
    static get is() {
        return 'research-tab-selector';
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                align-items: center;
                --current-slide: 0;
                --align-self: center;
            }
            ::slotted([slot='content']) {
                width: 100%;
            }
            ::slotted([slot='tab']) {
                white-space: nowrap;
            }
            .wrapper {
                overflow: hidden;
                width: 100%;
                max-width: 100%;
            }
            .content {
                display: grid;
                grid-auto-flow: column;
                grid-auto-columns: 100%;
                transition: transform 300ms ease-in-out;
                transform: translateX(calc(var(--current-slide) * -100%));
            }

            #bd-tabs {
                --height: unset;
                --tab-box-shadow: none;
                --tab-background-color: var(--color-invert-component-tr-80);
                align-self: var(--align-self);
            }

            @media (max-width: 600px) {
                .container {
                    overflow: scroll;
                }

                :host {
                    align-items: unset;
                  --align-self: start;
                }

                #bd-tabs {
                    max-width: 100vw;
                }

                  .wrapper {
                    width: unset;
                    margin: 0 var(--space-24);
                  }
            }
        `;
    }

    render() {
        return html`
            <bd-tabs
                id="bd-tabs"
                type="round"
                fallback-selection="${this.select}"
                size="mini"
                theme="light"
                align="left"
                attr-for-selected="name"
                no-line-background
                @selected-changed="${this._onTabSelectedChanged}"
            >
                <slot class="tab" name="tab" id="tab" slot="tab"></slot>
            </bd-tabs>
            <div class="wrapper">
                <div class="content">
                    <slot name="content" id="content"> </slot>
                </div>
            </div>
        `;
    }
    static get properties() {
        return {
            select: String,
        };
    }
    constructor() {
        super();
        this.select = 'tab1';
    }
    get bdTab() {
        return this.shadowRoot.querySelector('#bd-tabs');
    }
    get tabContents() {
        return this.shadowRoot.querySelector('#content').assignedNodes({flatten: true}) || [];
    }
    get tabs() {
        return this.shadowRoot.querySelector('#tab').assignedNodes({flatten: true}) || [];
    }
    _scrollToSelected(value, delay = 0) {
        if (!value) {
            value = this.bdTab.selected;
        }
        if (!value) {
            return;
        }
        if (!this._initialLoadDone) {
            this._initialLoadDone = true;
            return;
        }
        this.tabs.some((element) => {
            if (element.getAttribute('name') === value) {
                setTimeout(() => {
                    if ('scrollBehavior' in document.documentElement.style) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'nearest',
                        });
                    }
                }, delay);
                return true;
            }
        });
    }
    _onTabSelectedChanged(e) {
        const index = this.tabContents.findIndex((item) => {
            return item.getAttribute('name') === e.detail.value;
        });
        if (index > -1) {
            this.style.setProperty('--current-slide', index);
        }
        this._scrollToSelected(e.detail.value);

        this.dispatchEvent(
            new CustomEvent('tab-changed', {
                detail: {
                    id: index,
                },
            })
        );
    }
}
customElements.define(ResearchTabSelector.is, ResearchTabSelector);
